export default __webpack_public_path__ + "static/media/galin_l.ef14f40b.jpg";